export default __webpack_public_path__ + "static/media/dashboard.d4714b6c.svg";